export enum LOCALES {
  RU = 'ru',
  KK = 'kk'
}
